<template>
  <div class="cpnt-fil-rel">
    <table>
      <tr>
        <td>
          <!-- MOSTA O BOTÃO SELECIONAR TODOS -->
          <App-Button :data-time='time' v-if="[ 'seletor-data', 'input' ].indexOf(cpntTipo) === -1 && todos === true && cpntTodos !== ''" @onClick="cpntFilRelOnChangeTodos" :cpntDisabled="nenhum === true">
            <template v-if="nenhum !== true">
              <span class="nome" v-html="cpntNome"></span>
              <span class="espaco">&nbsp;</span>
              <span class="todos" v-html="'[' + cpntTodos + ']'"></span>
            </template>
            <span v-else v-html="'Não mostrar ' + cpntNome + ' no relatório.'"></span>
          </App-Button>         
  
          <!-- SETA OS CAMPOS QUE DEVE SER UTILIZADO -->
          <template v-else>
            <div class="sel-todos" v-if="[ 'seletor-data', 'input' ].indexOf(cpntTipo) === -1" :style="cpntTodos !== '' ? '' : 'height: 12px;'">
              <!-- SETA O TITULO DO CAMPO -->
              <span class="nome" v-html="cpntNome"></span>
              
              <!-- VERIFICA SE TEM O BOTÃO TODOS -->
              <template v-if="cpntTodos !== ''">
                <!-- SETA O BOTÃO SELECIONAR TODOS -->
                <App-Button :data-time='time' @onClick="cpntFilRelOnChangeTodos" :cpntClass="'btn btn-default btn-sm'">
                  Selecionar <span class="todos" v-html="cpntTodos"></span>
                </App-Button>
                  
                <!-- QUEBRA O FLOAT -->
                <span style="clear: both;">&nbsp;</span>
              </template>
            </div>
  
            <div class="campo">
              <App-Autocompletar :data-time='time' v-if="cpntTipo === 'autocomplite'"
              :cpntStatus='""'
              :cpntTabIndex='cpntTabIndex'
              :cpntNome='""'
              :cpntValue='value'         
              :cpntKeyMostra='cpntKeyMostra'
              :cpntKeyValue='cpntKeyValue'
              
              :cpntRouter='cpntRouter'
              :cpntMethod='cpntMethod'
              :cpntField='cpntField'
              :cpntWhere='cpntFilRelMontarWhere'
      
              :cpntOnChange='cpntFilRelOnChange'
              ref="campo"
              ></App-Autocompletar>

              <App-Select :data-time='time' v-else-if="cpntTipo === 'select'"
              :cpntStatus='""'
              :cpntTabIndex='cpntTabIndex'
              :cpntNome='""'
              :cpntValue='value'         
              :cpntKeyMostra='cpntKeyMostra'
              :cpntKeyValue='cpntKeyValue'

              :cpntOptions='options === null ? [] : options'

              :cpntOnChange='cpntFilRelOnChange'
              :cpntOnBuscarOptions='options === null ? cpntFilRelOnBuscarOptions : null'
              ref="campo"
              ></App-Select>

              <App-Seletor-Data :data-time='time' v-else-if="cpntTipo === 'seletor-data'" style="max-width: 340px; margin: 0px auto;" :class="cpntNome !== '' ? 'com-nome' : ''"
              :cpntStatus='""'
              :cpntTabIndex='cpntTabIndex'
              :cpntOptionInicialNome='cpntTodos'
              :cpntNome='cpntNome'
              :cpntValue='value'
              :cpntPosicao="'lado'"

              :cpntOnChange='cpntFilRelOnChange'
              ref="campo"
              ></App-Seletor-Data>

              <App-Calendario :data-time='time' v-else-if="cpntTipo === 'calendario'"
              :cpntStatus='""'
              :cpntTabIndex='cpntTabIndex'
              :cpntOptionInicialNome='cpntTodos'
              :cpntNome='""'
              :cpntValue='value'
              :cpntPosicao="'lado'"

              :cpntOnChange='cpntFilRelOnChange'
              ref="campo"
              ></App-Calendario>

              <!-- <div v-else-if="cpntTipo === 'input'" class="input">
              </div> -->
              <App-Input :data-time='time' v-else-if="cpntTipo === 'input'"
              :cpntStatus='""'
              :cpntTabIndex='cpntTabIndex'
              :cpntNome='cpntNome'
              :cpntValue='value'
              :cpntPosicao="'lado'"

              :cpntOnChange='cpntFilRelOnChange'
              :cpntOnKeyPressEnter='cpntFilRelOnChangeOnKeyPressEnter'
              ref="campo"
              ></App-Input>

              <div v-else-if="cpntTipo === 'intervalo'" class="intervalo">
                <App-Input :data-time='time'
                :cpntStatus='""'
                :cpntTabIndex='cpntTabIndex'
                :cpntNome='""'
                :cpntMask='"valorDecimalNovo"'
                :cpntValue='value.ini'
        
                :cpntOnChange='(value) => { cpntFilRelOnChangeIntervalo(value, "ini") }'
                ref="campo_ini"
                ></App-Input>

                <div class="intervalo-ate">até</div>

                <App-Input :data-time='time'
                :cpntStatus='""'
                :cpntTabIndex='cpntTabIndex'
                :cpntNome='""'
                :cpntMask='"valorDecimalNovo"'
                :cpntValue='value.fim'
        
                :cpntOnChange='(value) => { cpntFilRelOnChangeIntervalo(value, "fim") }'
                ref="campo_fim"
                ></App-Input>
              </div>
            </div>
          </template>

          <!-- SETA O BOTÃO NENHUM -->
          <template v-if="[ true, false ].indexOf(cpntNenhum) !== -1 && todos === true">
            <div :title="nenhum === true ? ('Desmarque está opção para realizar a busca com o filtro ' + cpntNome + '.') : ('Marque está opção para NÃO buscar com o filtro ' + cpntNome + '.')" class="cpnt-fil-rel--nenhum" :style="cpntNenhum === false ? 'visibility: hidden;' : ''">
              <input :id='cpntId + "--checkbox"' type="checkbox" class="app-checkbox" :checked="nenhum" :disabled="cpntNenhum === false" @change="cpntFilRelOnChangeNenhum">
              <label :for='cpntId + "--checkbox"'></label>
            </div>
          </template>
        </td>
      </tr>
      <tr v-if="todos !== true && cpntTabela.length >= 1" class="tabela">
        <td>
          <App-Tabela :data-time='time'
          :cpntColuna="colunas"
          :cpntLinha="linhas">
            <template v-slot:col_bandeira_pais="{ linha }">
              <img :src="'/img/bandeira/' + linha.img + '.png'" :title='linha.xPais'>
            </template>
  
            <template v-slot:col__remover="{ linha }">
              <App-Button :cpntIcone="'fa fa-times'" @onClick="() => { cpntFilRelRemoverLinha(linha) }"></App-Button>
            </template>
          </App-Tabela>
        </td>
      </tr>
    </table>
  </div>
</template>

<style scoped>
.cpnt-fil-rel {
  width: 100%;
}
  .cpnt-fil-rel > table {
    width: 100%;
  }
    .cpnt-fil-rel > table > tr:first-child > td {
      text-align: center;
    }
      .cpnt-fil-rel > table > tr > td > button {
        min-width: 200px;
        background: #f1f1f1;
        border-color: #ccc;
      }
.cpnt-fil-rel > table > tr > td > .cpnt-fil-rel--nenhum {
  display: inline-block
}

.cpnt-fil-rel > table > tr > td > button > span.todos {
  text-transform: uppercase;
}
.cpnt-fil-rel > table > tr > td > .campo {
}
  .cpnt-fil-rel > table > tr > td > .campo > .intervalo {
    padding-top: 5px
  }
    .cpnt-fil-rel > table > tr > td > .campo > .intervalo > .cpnt-app-input {
      width: calc((100% - 50px) / 2);
    }
    .cpnt-fil-rel > table > tr > td > .campo > .intervalo > .intervalo-ate {
      width: 50px;
      text-align: center;
      display: inline-block;
      line-height: 25px;
    }
  .cpnt-fil-rel > table > tr > td > .campo > .input {
    padding-top: 5px
  }
    .cpnt-fil-rel > table > tr > td > .campo > .input > .cpnt-app-input {
      width: 100%;
    }


.cpnt-fil-rel > table > tr > td > button > span.nome,
.cpnt-fil-rel > table > tr > td > .sel-todos > span.nome,
.cpnt-fil-rel > table > tr > td > .sel-todos > button > span.todos {
  text-transform: capitalize;
}

.cpnt-fil-rel > table > tr > td > .sel-todos {
  position: relative;
  padding-bottom: 2px;
  height: 24px;
  text-align: left;
}
.cpnt-fil-rel > table > tr > td > .sel-todos > span.nome {
  position: absolute;
  bottom: 0px;
  margin-right: 5px;
}
.cpnt-fil-rel > table > tr > td > .sel-todos > button {
  padding: 2px 8px !important;
  float: right;
}

</style>

<style>
.cpnt-fil-rel > table > tr.tabela > td > table > thead {
  display: none !important;
}
.cpnt-fil-rel > table > tr.tabela > td > table > tbody.qtde-lin--0 {
  display: none !important;
}
.cpnt-fil-rel > table > tr.tabela > td > table > tbody > tr > td {
  background: #f1f1f1;
  border-color: #ccc;
}
.cpnt-fil-rel > table > tr.tabela > td > table > tbody > tr > td.col__remover {
  width: 40px;
}
  .cpnt-fil-rel > table > tr.tabela > td > table > tbody > tr > td.col__remover > div > span > button {
    border: none !important;
  }

.cpnt-fil-rel > table > tr > td > .campo > .cpnt-seltor-data.com-nome > table > tr > td.seletor > div > label {
  top: -15px !important;
}
.cpnt-fil-rel > table > tr > td > .campo > .cpnt-seltor-data > table > tr > td.seletor > div > div > a {
  text-align: center !important;
}
</style>

<script>
  export default {
    props: {
      cpntId: {
        required: false,
        type: String,
        default: function () {
          // INICIA A VARIAVEL ID
          var id = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          // PROCURAR A MONTAGEM DO CAMPO
          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            id = 'cpnt-fil-rel-' + (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString() + '--'

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(id)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return id
        }
      },
      cpntTipo: {
        required: true,
        validator: function (val) {
          return [ 'autocomplite', 'select', 'seletor-data', 'intervalo', 'calendario', 'input' ].indexOf(val) !== -1
        }
      },
      cpntTabIndex: {
        required: false,
        type: Number,
        default: function () { return 0 }
      },
      cpntNome: {
        required: false,
        type: String,
        default: function () { return '' }
      },
      cpntTabela: {
        required: false,
        type: Array,
        default: function () { return [] }
      },
      cpntKeyValue: {
        required: false,
        type: String,
        default: function () { return 'id' }
      },
      cpntKeyMostra: {
        required: false,
        type: Array,
        default: function () { return [ 'nome' ] }
      },
      cpntTodos: {
        required: false,
        type: String,
        default: function () { return 'Todos' }
      },
      cpntValue: {
        required: false
      },
      cpntRouter: {
        required: false,
        type: String
      },
      cpntMethod: {
        required: false,
        type: String,
        default: function () { return '' },
        validator: function (val) {
          return [ '', 'GET', 'POST' ].indexOf(val) !== -1
        }
      },
      cpntField: {
        required: false,
        type: Object
      },
      cpntWhere: {
        required: false,
        type: [ Object, String, Function ],
      },

      
      cpntNenhum: {
        required: false,
        default: function () { return '' }
      },

      cpntOnBuscarOptions: {
        required: false
      }
    },
    components: {
      'App-Seletor-Data': () => import('@/components/_geral/Seletor-Data.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        value: '',
        options: null,
        colunas: [],
        linhas: [],
        todos: true,
        where: null,
        filtro: null,
        nenhum: false
      }
    },
    mounted: function () {
      // CHAMA A FUNÇÃO PARA MONTAR AS COLUNAS DA TABELA
      this.cpntFilRelMontarColunas()

      // CHAMA A FUNÇÃO PARA MONTAR AS COLUNAS DA TABELA
      this.cpntFilRelMontarWhere()

      // CHAMA A FUNÇÃO PARA ATUALIZAR O VALOR
      this.cpntFilRelAtualizarValor()
    },
    methods: {
      cpntFilRelSetaFocusCampo: function (campo, tentativa = 0) {
        if (tentativa <= 10) {
          // SETA A FUNÇÃO DE REINICIAR
          var reiniciar = () => { setTimeout(() => { this.cpntFilRelSetaFocusCampo(campo, (tentativa + 1)) }, 100) }

          // VERIFICA SE O CAMPO EXISTE
          if (tentativa >= 2 && [ '', null, undefined ].indexOf(this.$refs[campo]) === -1) {
            // PEGA O ELEMENTO QUE DEVE DAR FOCUS
            var elemento = Array.isArray(this.$refs[campo]) === true ? this.$refs[campo][0] : this.$refs[campo]

            // VERIFICA SE O ELEMENTO EXISTE
            if ([ '', null, undefined ].indexOf(elemento) === -1 && [ '', null, undefined ].indexOf(elemento.cpntRealizarFocus) === -1 && typeof elemento.cpntRealizarFocus === 'function') {
              elemento.cpntRealizarFocus()
            } else {
              reiniciar()
            }
          } else {
            reiniciar()
          }
        }
      },
      cpntFilRelOnChangeTodos: function () {
        // SETA O VALOR RECEBIDO
        this.$set(this, 'todos', !this.todos)
        
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA O FOCUS NO CAMPO
        if (this.todos === false) {
          // VERIFICA SE TEM QUE SETAR O VALOR NO CAMPO
          if (this.cpntTipo === 'intervalo') {
            // SETA O VALOR INICIAL DO CAMPO
            this.value = { ini: '0', fim: '0' }

            // SETA O FOCUS NO CAMPO INICIAL
            this.cpntFilRelSetaFocusCampo('campo_ini')
          } else {
            this.cpntFilRelSetaFocusCampo('campo')
          }
        } else {
          // LIMPA OS VALORES DO CAMPO
          this.$set(this, 'value', '')
          this.$set(this, 'linhas', [])
          this.$set(this, 'options', null)
          this.$set(this, 'nenhum', false)
        }
        
        // CHAMA A FUNÇÃO PARA ATUALIZAR
        this.cpntFilRelEnviarAtualizacao()
      },
      cpntFilRelOnChangeNenhum: function () {
        // SETA O VALOR RECEBIDO
        this.$set(this, 'nenhum', !this.nenhum)
        
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
        
        // CHAMA A FUNÇÃO PARA ATUALIZAR
        this.cpntFilRelEnviarAtualizacao()
      },
      cpntFilRelTratarValores: function (vetor) {
        // VERIFICA SE ESTÁ BUSCANDO VEICULO
        if (this.cpntRouter === '/veiculo/get') {
          for (var index in vetor) {
            if ([ '', null, undefined ].indexOf(vetor[index].ref_modelo) === -1) {
              // CONVERTE O MODELO
              vetor[index].id_mod = vetor[index].ref_modelo
              vetor[index].id_mod_nome = vetor[index].ref_modelo_j_modelo

              // CONVERTE A MARCA
              vetor[index].id_mar = vetor[index].ref_modelo_id_marca
              vetor[index].id_mar_nome = vetor[index].ref_modelo_id_marca_j_marca
            }
          }
        }

        // RETORNA O VALOR MONTADO
        return vetor
      },
      cpntFilRelOnBuscarOptions: function (callback) {
        if (this.options === null) {
          this.cpntOnBuscarOptions((options) => {
            // PEGA OS OPTIONS SOLICITADOS
            if (this.cpntTabela.length >= 1 && [ '', null, undefined ].indexOf(this.filtro) === -1) {
              options = options.filter(item => this.filtro.indexOf(item[this.cpntKeyValue]) === -1)
            }

            // TRATA O VALOR RECEBIDO
            options = this.cpntFilRelTratarValores(options)

            // SETA OS OPTIONS RECEBIDOS
            this.options = options
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
  
            // FINALIZA O PROCESSO DE BUSCA
            callback()
          })
        } else {
          // SETA OS OPTIONS RECEBIDOS
          this.options = []

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // FINALIZA O PROCESSO DE BUSCA
          callback()
        }
      },
      cpntFilRelOnChange: function (value) {
        // VERIFICA SE TEM TABELA A SER PREENCHIDA
        if ([ 'seletor-data', 'calendario', 'intervalo' ].indexOf(this.cpntTipo) === -1 && [ '', null, undefined ].indexOf(this.cpntTabela) === -1) {
          if (this.cpntTabela.length >= 1) {
            // TRATA O VALOR RECEBIDO
            value = this.cpntFilRelTratarValores([ value ])

            // ADICIONA O VALOR RECEBIDO A TABELA
            this.linhas.push(JSON.parse(JSON.stringify(value[0])))
            
            // LIMPA O VALOR DO CAMPO
            setTimeout(() => {
              // LIMPA O VALOR DO CAMPO
              this.$set(this, 'value', '')
  
              // LIMPA OS OPTIONS DO SELETOR
              this.$set(this, 'options', null)
  
              // SETA O FOCUS NO CAMPO
              if (this.cpntTipo !== 'select') {
                this.cpntFilRelSetaFocusCampo('campo')
              }
            }, 250)
          }
        }
        
        // VERIFICA O VALOR RECEBIDO
        if (this.cpntTipo === 'autocomplite' && (this.cpntTipo === 'select' && this.cpntTodos === '')) {
          value = Array.isArray(value) === true ? value[0] : value
        }
        
        // SETA O VALOR RECEBIDO
        this.$set(this, 'value', value)
        
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
        
        // CHAMA A FUNÇÃO PARA ATUALIZAR
        this.cpntFilRelEnviarAtualizacao()
      },
      cpntFilRelOnChangeOnKeyPressEnter: function () {
        this.$emit('cpntOnKeyPressEnter', this.cpntId)
      },
      cpntFilRelOnChangeOnKeyDown: function () {
        this.$emit('cpntOnKeyDown', this.cpntId)
      },
      cpntFilRelMontarColunas: function () {
        // PEGA O NOME DAS COLUNAS
        var colunas = JSON.parse(JSON.stringify(this.cpntTabela))

        // ADICIONA A COLUNA REMOVER NO FINAL
        colunas.push({ nome: 'Remover', chave: '_remover' })

        // SETA A EXIBIÇÃO DAS COLUNAS
        for (var index in colunas) {
          colunas[index].mPer = 1
        }

        // SETA AS COLUNAS MONTADAS
        this.colunas = colunas

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cpntFilRelRemoverLinha: function (linha) {
        // PEGA O NOME DA CHAVE QUE TEM O VALOR PARA COMPARAR
        var chave = this.cpntKeyValue

        // PEGA O ID QUE DEVE REMOVER
        var remover = linha[chave]
        
        // REMOVE A LINHA SOLICITADA
        this.linhas = this.linhas.filter(item => item[chave] !== remover)

        // LIMPA OS OPTIONS DO SELETOR
        this.$set(this, 'options', null)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA ATUALIZAR
        this.cpntFilRelEnviarAtualizacao()
      },
      cpntFilRelEnviarAtualizacao: function () {
        // INICIA A VARIAVEL
        var value = ''

        // VERIFICA SE ESTÁ DESMARCADO A OPÇÃO TODOS
        if ([ 'seletor-data', 'calendario', 'intervalo', 'input' ].indexOf(this.cpntTipo) !== -1 || (this.cpntTipo === 'select' && this.cpntTodos === '')) {
          value = this.value
        } else if (this.nenhum === true) {
          value = '__NENHUM__'
        } else if (this.todos === false && this.cpntTabela.length === 0) {
          value = ([ '', null, undefined ].indexOf(this.value) !== -1 || (Array.isArray(this.value) === true && this.value.length === 0)) ? '' : this.value[this.cpntKeyValue]
        } else if (this.todos === false) {
          // SETA O NOVO VALOR DO CAMPO
          value = []

          // SETA A EXIBIÇÃO DAS COLUNAS
          for (var index in this.linhas) {
            value.push(this.linhas[index][this.cpntKeyValue])
          }

          // REMOVE OS VALORES DUPLICADOS
          value = value.filter((v, i, a) => a.indexOf(v) === i)
        }

        // SETA O VALOR DO FILTRO SELECIONADO
        this.filtro = JSON.parse(JSON.stringify(value))

        // DESTRAVA A TELA
        this.$emit('UPDATE_VALUE_FILTRO', value)
      },
      cpntFilRelMontarWhere: function () {
        return new Promise((success) => {
          if ([ '', null, undefined ].indexOf(this.cpntWhere) === -1) {
            // INICIA A VARIAVEL
            var where = []

            // CRIA PROMISSE PARA MONTAR O WHERE
            new Promise((successW) => {
              // VERIFICA O TIPO DE REGISTRO
              if (typeof this.cpntWhere === 'function') {
                // CARREGA OS DADOS DO CAMPO
                var whereRet = this.cpntWhere(this.cpntId)
                      
                // VERIFICA SE O RETORNO É UM PROMISSE OU NÃO
                if (typeof whereRet === 'object' && typeof whereRet.then === 'function') {
                  whereRet.then((retorno) => {
                    // PEGA O WHERE RECEBIDO
                    where = retorno

                    // FINALIZA O CARREGAMENTO
                    successW()
                  })
                } else {
                  // PEGA O WHERE RECEBIDO
                  where = whereRet

                  // FINALIZA O CARREGAMENTO
                  successW()
                }
              } else {
                // PEGA O WHERE SOLICITADO
                where = JSON.parse(JSON.stringify(this.cpntWhere))

                // FINALIZA O CARREGAMENTO
                successW()
              }
            }).then(() => {
              // MONTA O WHERE QUE DEVE REALIZAR
              if (this.cpntValue === '__NENHUM__') {
                where = { aAnd: [ { f: this.cpntKeyValue, o: '=', v: '' } ].concat(where) }
              } else if ([ '', null, undefined ].indexOf(this.cpntValue) === -1) {
                where = { aAnd: [ { f: this.cpntKeyValue, o: 'notIn', v: this.cpntValue.join() } ].concat(where) }
              }
      
              // SETA O WHERE MONTADO
              this.where = where

              // FINALIZA O CARREGAMENTO
              success(where)
            })    
          } else {
            success({})
          }
        })
      },
      cpntFilRelAtualizarValor: function () {
        if (this.filtro === null || (JSON.stringify(this.filtro) !== JSON.stringify(this.cpntValue))) {
          if ([ true, false ].indexOf(this.cpntNenhum) !== -1 && this.cpntValue === '__NENHUM__') {
            // SETA O VALOR RECEBIDO
            this.$set(this, 'todos', true)

            // LIMPA OS VALORES DO CAMPO
            this.$set(this, 'value', '')
            this.$set(this, 'linhas', [])
            this.$set(this, 'options', null)

            // SETA O VALOR DE NENHUM
            this.$set(this, 'nenhum', true)
            
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA ATUALIZAR
            this.cpntFilRelEnviarAtualizacao()
          } else if (this.cpntValue === '') {
            // SETA O VALOR RECEBIDO
            this.$set(this, 'todos', true)

            // LIMPA OS VALORES DO CAMPO
            this.$set(this, 'linhas', [])
            this.$set(this, 'options', null)
            this.$set(this, 'nenhum', false)
            
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
            
            // CHAMA A FUNÇÃO PARA ATUALIZAR
            this.cpntFilRelEnviarAtualizacao()
          } else if ([ '', null, undefined ].indexOf(this.cpntOnBuscarOptions) === -1 && (this.cpntTipo === 'select' && this.cpntTodos === '')) {
            this.cpntFilRelOnBuscarOptions(() => {
              // SETA O VALOR RECEBIDO
              this.$set(this, 'todos', false)

              // SETA O VALOR DE NENHUM
              this.$set(this, 'nenhum', false)

              // PEGA OS OPTIONS SOLICITADOS
              var options = typeof this.cpntValue !== 'string' ? [ this.cpntValue ] : JSON.parse(JSON.stringify(this.options)).filter(item => item[this.cpntKeyValue] === this.cpntValue)
              
              // LIMPA O VALOR DO CAMPO
              this.$set(this, 'value', (options.length >= 1 ? options[0] : ''))
              this.$set(this, 'options', null)

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
              
              // CHAMA A FUNÇÃO PARA ATUALIZAR
              this.cpntFilRelEnviarAtualizacao()
            })
          } else if ([ '', null, undefined ].indexOf(this.cpntOnBuscarOptions) === -1) {
            this.cpntFilRelOnBuscarOptions(() => {
              // SETA O VALOR RECEBIDO
              this.$set(this, 'todos', false)

              // SETA O VALOR DE NENHUM
              this.$set(this, 'nenhum', false)

              // PEGA OS OPTIONS SOLICITADOS
              var options = JSON.parse(JSON.stringify(this.options)).filter(item => this.cpntValue.indexOf(item[this.cpntKeyValue]) !== -1)

              // ADICIONA O VALOR RECEBIDO A TABELA
              this.linhas = options
              
              // REMOVE OS VALORES DUPLICADOS
              this.linhas = this.linhas.filter(function (a) {
                return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true)
              }, Object.create(null))

              // this.linhas = this.linhas.filter((v, i, a) => [ '', null, undefined ].indexOf(v) === -1 && a.indexOf(v) === i)
              
              // LIMPA O VALOR DO CAMPO
              this.$set(this, 'value', '')
              this.$set(this, 'options', null)

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
              
              // CHAMA A FUNÇÃO PARA ATUALIZAR
              this.cpntFilRelEnviarAtualizacao()
            })
          } else if (Array.isArray(this.cpntValue) === true && this.cpntValue.length === 0) {
            // SETA O VALOR RECEBIDO
            this.$set(this, 'todos', false)

            // SETA O VALOR DE NENHUM
            this.$set(this, 'nenhum', false)

            // LIMPA A LINHA DA TABELA
            this.linhas = []
            
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
            
            // CHAMA A FUNÇÃO PARA ATUALIZAR
            this.cpntFilRelEnviarAtualizacao()
          } else if (Array.isArray(this.cpntValue) === true && this.cpntValue.length >= 1) {
            // PEGA APENAS NOVOS VALORES
            var buscar = this.cpntValue.filter(item => ([ '', null, undefined ].indexOf(item) === -1))

            // VERIFICA SE TEM ALGUMA COISA PARA BUSCAR
            if (buscar.length >= 1) {
              // INICIA A QUERY
              var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }
    
              // SETA OS CAMPOS QUE DEVE BUSCAR
              queryGet.field = this.cpntField
    
              // SETA OS CAMPOS QUE DEVE BUSCAR
              queryGet.where = { aAnd: [ { f: this.cpntKeyValue, o: 'in', v: this.cpntValue.join() } ] }
  
              // CHAMA FUNÇÃO PARA COMUNICAR COM API
              this.$store.state.comunicaAPI(this.cpntRouter, this.cpntMethod, queryGet, (retorno) => {
                // SETA O VALOR RECEBIDO
                this.$set(this, 'todos', false)

                // SETA O VALOR DE NENHUM
                this.$set(this, 'nenhum', false)
  
                // TRATA O VALOR RECEBIDO
                retorno.data = this.cpntFilRelTratarValores(JSON.parse(JSON.stringify(retorno.data)))
  
                // ADICIONA O VALOR RECEBIDO A TABELA
                this.linhas = retorno.data

                // REMOVE OS VALORES DUPLICADOS
                this.linhas = this.linhas.filter(function (a) {
                  return (!this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true))
                }, Object.create(null))
                
                // LIMPA O VALOR DO CAMPO
                this.$set(this, 'value', '')
  
                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()
                
                // CHAMA A FUNÇÃO PARA ATUALIZAR
                this.cpntFilRelEnviarAtualizacao()
              }, this.cpntFilRelSetarStatusGeral)
            }
          } else if ([ 'intervalo' ].indexOf(this.cpntTipo) !== -1) {
            // SETA O VALOR DO CAMPO
            this.value = this.cpntValue

            // LIMPA O VALOR DO CAMPO
            this.$set(this, 'options', null)
            this.$set(this, 'linhas', [])

            // SETA O VALOR DE NENHUM
            this.$set(this, 'nenhum', false)

            // SETA O BOTÃO TODOS
            this.$set(this, 'todos', [ '', null, undefined ].indexOf(this.cpntValue) !== -1)

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          } else if ([ 'seletor-data', 'calendario' ].indexOf(this.cpntTipo) !== -1) {
            // SETA O VALOR DO CAMPO
            this.value = this.cpntValue

            // LIMPA O VALOR DO CAMPO
            this.$set(this, 'options', null)
            this.$set(this, 'linhas', [])

            // SETA O VALOR DE NENHUM
            this.$set(this, 'nenhum', false)

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }
        }
      },
      cpntFilRelOnChangeIntervalo: function (value, campo) {
        // SETA O VALOR RECEBIDO NO CAMPO
        this.value[campo] = value

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cpntFilRelSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    },
    watch: {
      cpntTabela: function () {
        this.cpntFilRelMontarColunas()
      },
      cpntValue: function () {
        // MANDA ATUALIZAR O VALOR
        this.cpntFilRelAtualizarValor()

        // MANDA ATUALIZAR O WHERE
        this.cpntFilRelMontarWhere()
      }
    }
  }
</script>
